export const ARTICLE_GROUPS_REQUESTED = "ARTICLE_GROUPS_REQUESTED";
export const ARTICLE_GROUPS_RECEIVED = "ARTICLE_GROUPS_RECEIVED";
export const ARTICLE_GROUPS_REQUEST_FAILED = "ARTICLE_GROUPS_REQUEST_FAILED";

export const CUTOFF_CAMPAIGN_REQUESTED = "CUTOFF_CAMPAIGN_REQUESTED";
export const CUTOFF_CAMPAIGN_RECEIVED = "CUTOFF_CAMPAIGN_RECEIVED";
export const CUTOFF_CAMPAIGN_REQUEST_FAILED = "CUTOFF_CAMPAIGN_REQUEST_FAILED";

export const requestArticleGroups = () => ({ type: ARTICLE_GROUPS_REQUESTED });
export const receiveArticleGroups = payload => ({ type: ARTICLE_GROUPS_RECEIVED, payload });

export const requestCutoffCampaign = name => ({ type: CUTOFF_CAMPAIGN_REQUESTED, name });
export const receiveCutoffCampaign = payload => ({ type: CUTOFF_CAMPAIGN_RECEIVED, payload });
